/* eslint-disable global-require */
/* eslint-disable consistent-return */
import React, {
  createContext,
  ReactNode,
  useReducer,
  useEffect,
  useContext,
} from 'react';
import { ReportsGlobalContext } from '@mummssoftware/global-context';
import { Reporting } from '@mummssoftware/utils';
import {
  SET_REPORTS_ERROR,
  SET_SHOW_LOADER,
  SET_OPEN_REPORT,
  SET_REPORTS_LIST,
} from './constants';
import { Context } from '../../context';

type ReportsContextProviderProps = {
  children: ReactNode;
  reporting: Reporting;
};

type initFunction = () => undefined;

const initFunc = () => undefined;

type ReportsContext = {
  reportList: mumms.ReportDTO[] | null;
  showLoader: boolean;
  reportsError: string | null;
  reportOpen: mumms.ReportDTO | null;
  dispatch: any;
};

type ReportsContextState = {
  reportList: mumms.ReportDTO[] | null;
  showLoader: boolean;
  reportsError: string | null;
  reportOpen: mumms.ReportDTO | null;
  dispatch: any;
};

const initialState = {
  reportList: null,
  showLoader: false,
  reportsError: null,
  reportOpen: null,
  dispatch: initFunc,
};

const initREPORTSContext = {
  reportList: null,
  showLoader: false,
  reportsError: null,
  reportOpen: null,
  dispatch: initFunc,
};

export const ReportsContextReducer = (
  state: ReportsContextState,
  action: { type: string; payload: mumms.ComponentName | any },
) => {
  let newState = { ...state };
  switch (action.type) {
    case SET_REPORTS_LIST:
      newState.reportList = action.payload;
      break;
    case SET_REPORTS_ERROR:
      newState.reportsError = action.payload;
      break;
    case SET_SHOW_LOADER:
      newState.showLoader = action.payload;
      break;
    case SET_OPEN_REPORT:
      newState.reportOpen = action.payload;
      break;
    default:
      newState = state;
      break;
  }
  return newState;
};

export const ReportsContext = createContext<ReportsContext>(
  initREPORTSContext as ReportsContext,
);
export const ReportsContextProvider = ({
  children,
  reporting,
}: ReportsContextProviderProps) => {
  const [
    { showLoader, reportsError, reportOpen, reportList },
    dispatch,
  ] = useReducer(ReportsContextReducer, initialState);
  const { reportListGroup, agency } = useContext(Context);
  const { reportsListGlobal } = useContext(ReportsGlobalContext);

  useEffect(() => {
    if (!reportsListGlobal) return;

    const list = reportListGroup
      ? reportsListGlobal?.filter(
          (report: any) => report.reportGroup === reportListGroup,
        )
      : reportsListGlobal;
    dispatch({ type: SET_REPORTS_LIST, payload: list });
  }, [reportsListGlobal]);

  return (
    <ReportsContext.Provider
      value={{
        showLoader,
        reportsError,
        reportOpen,
        reportList,
        dispatch,
      }}
    >
      {children}
    </ReportsContext.Provider>
  );
};

export default ReportsContextProvider;
